import { computed, ref } from 'vue';

let auth = () => {};
let totalTimeOut = '';
let interval;
export const AUTHENTICATION_STATUS = Object.freeze({
  READY: 'READY', // 처음 진입
  ON_GOING: 'ON_GOING', // 발급
  TIME_OUT: 'TIME_OUT', // 만료
  COMPLETED: 'COMPLETED' // 성공
});

export const authState = ref(AUTHENTICATION_STATUS.READY);
let authTimer = ref('');

let authAccessTime = '';

export const timer = computed(() => authTimer.value);
export const phoneState = computed(() => authState.value);

export const initialize = (timeout = '03:00', authenticateFunction = () => {}) => {
  authTimer.value = timeout;
  totalTimeOut = timeout;
  authState.value = AUTHENTICATION_STATUS.READY;
  auth = authenticateFunction; // authCode 가져오는 함수로변환
};

export const finishAuth = (isDone = false) => {
  if (isDone) {
    clearInterval(interval);
    authState.value = AUTHENTICATION_STATUS.COMPLETED;
  }
};
export const doAuth = async () => {
  if (authState.value === AUTHENTICATION_STATUS.COMPLETED) return false;
  const result = await auth();
  if (result !== true) {
    authState.value = AUTHENTICATION_STATUS.READY;
    return result;
  }
  reset();
  if (interval) clearInterval(interval);
  interval = setInterval(() => {
    authTimer.value = calculateMinutes(authTimer.value);
    if (authTimer.value == '00:00') {
      clearInterval(interval);
      authState.value = AUTHENTICATION_STATUS.TIME_OUT;
    }
  }, 1000);
  return true;
};

const reset = () => {
  authState.value = AUTHENTICATION_STATUS.ON_GOING;
  authTimer.value = totalTimeOut; // 정해진 시간으로 다시 리셋
  authAccessTime = new Date();
};

const calculateMinutes = () => {
  const currentTime = new Date();
  const timeDiffInSeconds = Math.floor((currentTime - authAccessTime) / 1000); // 초 단위로 변환
  // totalTimeOut을 분과 초로 분리하고 숫자로 변환
  const [totalMinutes, totalSeconds] = totalTimeOut.split(':').map(Number);
  // 타이머 지속 시간 설정 (초 단위로 변환)
  const timerDurationInSeconds = totalMinutes * 60 + totalSeconds;
  // 남은 시간 계산 (초 단위)
  let remainingTimeInSeconds = timerDurationInSeconds - timeDiffInSeconds;
  // 남은 시간이 음수이거나 0보다 작으면 0으로 설정
  remainingTimeInSeconds = Math.max(remainingTimeInSeconds, 0);
  // 시간, 분, 초 계산
  let minutes = Math.floor(remainingTimeInSeconds / 60);
  let seconds = remainingTimeInSeconds % 60;
  // "00:00" 형식으로 포맷팅
  return `${paddingLeftZero(minutes)}:${paddingLeftZero(seconds)}`;
};
const paddingLeftZero = number => {
  return number < 10 ? `0${number}` : number;
};
